import { useState } from 'react';
import { useExportReport } from '../../hooks/useReports';
import type { ExportRequest } from '@recruitai/shared';

interface ExportButtonProps {
  reportType: 'dashboard' | 'job' | 'recruiter' | 'platform';
  startDate: string;
  endDate: string;
  jobId?: string;
  userId?: string;
}

export function ExportButton({ reportType, startDate, endDate, jobId, userId }: ExportButtonProps) {
  const [open, setOpen] = useState(false);
  const { exportReport, isLoading } = useExportReport();

  const handleExport = async (format: 'pdf' | 'csv') => {
    setOpen(false);
    const request: ExportRequest = {
      reportType,
      format,
      filters: { startDate, endDate, jobId, userId },
    };
    const result = await exportReport(request);
    if (result?.downloadUrl) {
      window.open(result.downloadUrl, '_blank');
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        disabled={isLoading}
        className="px-3 py-1.5 text-sm border rounded bg-white hover:bg-gray-50 disabled:opacity-50"
        aria-label="Exportar relatório"
      >
        {isLoading ? 'Exportando...' : 'Exportar'}
      </button>
      {open && (
        <div className="absolute right-0 mt-1 bg-white border rounded shadow-lg z-10">
          <button
            onClick={() => handleExport('pdf')}
            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
          >
            PDF
          </button>
          <button
            onClick={() => handleExport('csv')}
            className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
          >
            CSV
          </button>
        </div>
      )}
    </div>
  );
}
